
export const setSystem = value => {
    return { type: 'SETSYSTEM', payload:value}
}




// WEBPACK FOOTER //
// ./src/actions/systemActions.js